import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { DelayTimer, KeyboardEventKeyCode, Themes } from 'consts';
import { isTheme, onFocusRef } from 'utils';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/modal/Modal.scss';

export const ModalDirection = {
  Top: 'modal-top',
  Bottom: 'modal-bottom',
  Left: 'modal-left',
  Right: 'modal-right'
};

const Modal = ({
  children,
  className,
  direction,
  theme,
  showModal,
  onClose,
  openFocusRef,
  closeFocusRef,
  ariaLabeledById,
  id,
  focusable = false,
  escapable = true
}) => {
  if (!children) {
    return null;
  }
  const directionClass = direction ? direction : ModalDirection.Bottom;
  const themeClass = isTheme(theme) ? `theme-${theme}` : `theme-${Themes.Dark}`;
  const showClass = showModal ? 'show-modal' : '';
  const modalClassName = `csw-modal ${themeClass} ${directionClass} ${showClass} ${className ? className : ''}`;
  const modalGlassClassName = `csw-modal-glass ${showModal ? 'show-glass' : ''} ${onClose ? 'glass-closable' : ''}`;

  const onModalClose = onClose ? onClose : () => {
    //Do nothing
  };

  // useEffect for showModal, focusable
  useEffect(() => {
    showModal && focusable && setTimeout(setMenuFocus, DelayTimer.WidgetMenuFocusDelay);
  }, [showModal, focusable]);

  const setMenuFocus = () => {
    const focusRef = showModal ? openFocusRef : closeFocusRef;

    return focusable && onFocusRef(focusRef);
  };

  const escapeKeyHandler = (e) => escapable && e && e.keyCode === KeyboardEventKeyCode.Escape
    && onModalClose();

  return (
    [
      showModal ? <div className={modalGlassClassName}
                       key="modal-glass"
                       onClick={onModalClose}>{' '}</div> : null,
      <div className={modalClassName}
           role="dialog"
           key="modal-container"
           id={id}
           aria-hidden={!showModal}
           aria-labelledby={ariaLabeledById}
           onKeyUp={escapeKeyHandler}>
        <div className="csw-modal-content">
          {children}
        </div>
      </div>
    ]
  );
};

Modal.propTypes /* remove-proptypes */ = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  direction: PropTypes.string,
  theme: PropTypes.string,
  showModal: PropTypes.bool,
  onClose: PropTypes.func,
  openFocusRef: PropTypes.object,
  closeFocusRef: PropTypes.object,
  ariaLabeledById: PropTypes.string,
  focusable: PropTypes.bool,
  escapable: PropTypes.bool
};

export default Modal;
